import React from 'react'
import { Container, Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'
const Footer = () => {
    return (
        <>
            <footer className='pb-0' style={{ background: "#f96800" }}>
                <Container className='pt-3'>
                    <div className="d-lg-flex gap-4 d-block justify-content-between align-items-center">

                        <div className='text-center text-lg-end mb-3'>

                            <Image src={"https://d2bxnt3cp18qf5.cloudfront.net/footerlogo.webp"} width={"100px"} />


                        </div>

                        <div className="text-center mb-3 mb-lg-0">
                            <p style={{ color: "#000000" }} className='abreviation paragraphtext  mb-1 ' >Sponsor: Polaris Inc. No purchase necessary. Open to permanent, legal residents of the United States excluding Puerto Rico, Guam, the U.S. Virgin Islands, and other U.S. territories. Persons under 18 years of age are prohibited from entry. Giveaway starts on November 18th, 2024 at 12:00 PM PT and ends December 16th, 2024 at 11:59 PM PT. Prize as indicated on Platform, subject to <Link target='_blank' className=' text-white' to={"https://officialrules.s3.us-east-2.amazonaws.com/Official+Giveaway+Rules+-+Polaris+-+FINAL.pdf"}>OFFICIAL GIVEAWAY RULES</Link>. Void where prohibited.</p>
                        </div>
                        <div>
                            <div className="d-lg-flex d-block align-items-center gap-2 text-center text-lg-end">
                                {/* <div className='mb-3'>
                                    <Link target='_blank' className=' text-black fw-bold me-lg-3 me-0' to={"https://officialrules.s3.us-east-2.amazonaws.com/Official+Giveaway+Rules+-+Polaris+-+FINAL.pdf"}>OFFICIAL GIVEAWAY RULES</Link>

                                </div> */}
                                <div >
                                    <Image className='' src={"https://d2bxnt3cp18qf5.cloudfront.net/Detailed_rating_icon_2_axuhqm.png"} width={"140px"} />
                                </div>
                            </div>

                        </div>

                    </div>
                    <hr className='text-black bg-black' />
                    <div className='text-center pb-2'>
                        <p className='copyright-text text-black'>© 2024 Activision Publishing, Inc. ACTIVISION, CALL OF DUTY, CALL OF DUTY BLACK OPS, and CALL OF DUTY WARZONE are trademarks of Activision Publishing, Inc. All other trademarks and trade names are the property of their respective owners.</p>
                    </div>
                </Container>
            </footer>
        </>
    )
}

export default Footer